import React, { useCallback, useContext, useState } from "react";
import { clearFilterData, initFilterData } from "./initData";
import SearchButton from "components/buttons/SearchButton";
import ClearButton from "components/buttons/ClearButton";
import { Box, TextField } from "@mui/material"
import BoxFilter from "components/BoxCustom/BoxFilter";
import ComboBox from "components/ComboBox";
import { GlobalStateContext } from "contexts/GlobalStateContext";
import DateTimeSelect from "components/DateTimeSelect";
import { billingNoteColNm } from "constants/billingNoteConstant";
import AddButton from "components/buttons/AddButton";


const BillingNoteFilter = ({ onSearchButtonClick, onAddButtonClick }) => {
  const [filterData, setFilterData] = useState(initFilterData);
  const { msData } = useContext(GlobalStateContext);



  const filterProps = useCallback((name) => ({
    variant: "outlined",
    size: "small",
    name: name,
    sx:{width:180},
    label: billingNoteColNm[name],
    value: filterData[name] || "", 
    onKeyUp: e => {if(e.code === "Enter" || e.code === "NumpadEnter"){onSearchButtonClick(filterData)} }, 
    onChange: (e) => { setFilterData(oldState => ({ ...oldState, [name]: e.target.value || null })) }
  }), [filterData, onSearchButtonClick])

  console.log("filterData::", filterData)
  return (
    <Box display="flex">
      <AddButton onClick={onAddButtonClick}>เพิ่มใบวางบิล</AddButton>

      <BoxFilter>

        <DateTimeSelect
          sx={{ width: 180 }}
          label="วันที่ใบวางบิล"
          start={filterData.BNDteSt}
          end={filterData.BNDteEn}
          setSelectDate={(start, end) => { setFilterData(o => ({ ...o, BNDteSt: start, BNDteEn: end })) }}
          getData={() => { onSearchButtonClick(filterData) }}
        />
        <TextField {...filterProps("BNNo")} />
        <ComboBox sx={{ width: 200 }} options={msData.cusCombo} label="ลูกค้า"
          selectedId={filterData.CusId}
          setSelectedId={(id)=>setFilterData(o => ({ ...o, CusId: id}))}
        />
        <SearchButton onClick={() => { onSearchButtonClick(filterData) }} />
        <ClearButton onClick={() => { setFilterData(clearFilterData) }} />
      </BoxFilter>
    </Box>
  )
}

export default React.memo(BillingNoteFilter)
